import { cn } from '@anytag/shared-utils';
import { Tooltip, TooltipProps } from '../Tooltip';
import { Icon, IconProps } from './Icon';

export interface HelpIconProps extends Omit<TooltipProps, 'children' | 'variant'> {
  size?: string;
  className?: string;
  variant?: IconProps['variant'];
}

export const HelpIcon = ({ className, size = '12px', variant = 'light-gray', ...restProps }: HelpIconProps) => (
  <Tooltip place="top" {...restProps}>
    {/* IcoMoon itself cannot forward ref, but Tooltip require it to work */}
    <div className={cn('inline-flex', className)} style={{ width: size, height: size }}>
      <Icon size={size} icon="tooltip" variant={variant} className="cursor-pointer hover:brightness-90" />
    </div>
  </Tooltip>
);
